// mutations.js

export default {
    removeIncidentFromList(state, id) {
        if (state.incidents && state.incidents.data) {
            state.incidents.data = state.incidents.data.filter(incident => incident.id !== id);
            state.incidents.total = state.incidents.data.length;
        }
    },
};
